<div class="form-input text-field-edit">
  <mat-form-field>
    <input matInput
           readonly="true"
           [value]="config.value"
           [placeholder]="config.fieldLabel | translate">

    <button *ngIf="config.actionLabel"
            class="btn btn--clear"
            (click)="onButtonClick()">
      {{ config.actionLabel | translate }}
      <span class="material-icons">arrow_right</span>
    </button>

  </mat-form-field>
</div>
